import {Feature} from "geojson";
import "./MapFeatureMonitoringDetailsComponent.scss";
import {useMemo} from "react";
import {TranslationsService} from "../../services/Translations.service";
import {
    MaterialReactTable,
    MRT_Cell,
    MRT_ColumnDef,
    useMaterialReactTable,
} from 'material-react-table';
import {MonitoringFeature, MonitoringIndicator} from "../../shared/interfaces";

interface MapFeatureDetailsProps {
    feature: Feature | null;
    layerName: string;
    isActive: boolean;
    onClose: () => void;
}

const data = [
    {
        name: "John",
        age: 30
    },
    {
        name: "Sara",
        age: 25
    }
];

const MapFeatureMonitoringDetailsComponent: React.FC<MapFeatureDetailsProps> = ({feature, layerName, isActive, onClose}) => {
    const LAYER_FIELDS = useMemo(() => TranslationsService.getTranslations(layerName) || {}, [layerName]);
    const indicators = (feature?.properties as MonitoringFeature)?.indicators ?? {};

    const columns = useMemo(
        () => [
            {
                accessorKey: "title",
                header: "Речовини",
                muiTableHeadCellProps: { style: { width: "50px", whiteSpace: 'wrap', color: "#284b6c" } },
                muiTableBodyCellProps: { style: { width: "50px", whiteSpace: 'wrap', color: "#284b6c" } },
            },
            {
                accessorKey: "norm",
                header: "Норматив",
                muiTableHeadCellProps: { style: { color: "#284b6c" } },
                muiTableBodyCellProps: {style: {width: "100%", whiteSpace: 'wrap', color: "#284b6c"}},
                Cell: ({ row }: any) => {
                    const cleaned = row.original.norm.toString().replace(/;$/, "");
                    const result = cleaned.replace(/;/g, " - ");
                    return (
                      <span>{result}</span>
                    );
                  }
            },
            {
                accessorKey: "value",
                header: "Показники",
                muiTableHeadCellProps: { style: { color: "#284b6c" } },
                muiTableBodyCellProps: {style: {width: "100%", whiteSpace: 'wrap', color: "#284b6c"}},
                Cell: ({ row }: any) => {
                    const value = parseFloat(row.original.value);
                    const cleanedNorm = row.original.norm.toString().replace(/;$/, "");
                    const normValueArr = cleanedNorm.replace(/;/g, " - ").split("-");
                    const isExceeding = normValueArr.every((norm: string) => value > parseFloat(norm));
                
                    return (
                      <span style={{ color: isExceeding ? 'red' : '#284b6c' }}>
                        {row.original.value}
                      </span>
                    );
                  }
            }
        ],
        []
    );

    const data = useMemo<MonitoringIndicator[]>(
        () => Object.values(indicators),
        [indicators]
    );

    const table = useMaterialReactTable({
        columns,
        data,
        initialState: {
            pagination: {
              pageIndex: 0,
              pageSize: 5 
            },
            density: 'compact'
          },
        enableKeyboardShortcuts: false,
        enableColumnActions: false,
        enableColumnFilters: false,
        enableSorting: false,
        enablePagination: false,
        renderTopToolbar: false,
        renderBottomToolbar: false,
        muiTableContainerProps: {
        },
      });

    return (
        <div className={`feature_monitoring_wrapper ${isActive ? "active" : ""}`}>
            <div className="feature_header">
                <div className="close">
                    <img onClick={onClose} src="/assets/icons/cross_white.png" alt="Close" />
                </div>
                <div className="feature_header_title">{layerName}</div>
            </div>
            <div className="feature_content">
                {feature?.properties ? (
                    <div className="feature_fields">
                        {Object.entries(feature.properties ?? {}).map(([key, value]) => (
                            LAYER_FIELDS[key] ? (
                                <div className="feature_field" key={key}>
                                    <div className="feature_field_header">{LAYER_FIELDS[key] || key}:</div>
                                    <div className="feature_field_text">{String(value)}</div>
                                </div>
                            ) : ""
                        ))}
                        <MaterialReactTable table={table} />
                    </div>
                ) : (
                    <p>No feature selected</p>
                )}
            </div>
        </div>
    );
};

export default MapFeatureMonitoringDetailsComponent;
